__turbopack_context__.v({
  "bar": "DIthVW_bar",
  "cta": "DIthVW_cta",
  "ctaLabel": "DIthVW_ctaLabel",
  "ctaShrinkable": "DIthVW_ctaShrinkable",
  "figure": "DIthVW_figure",
  "inner": "DIthVW_inner",
  "price": "DIthVW_price",
  "priceLabel": "DIthVW_priceLabel",
  "priceRow": "DIthVW_priceRow",
  "status": "DIthVW_status",
  "suffix": "DIthVW_suffix",
  "was": "DIthVW_was",
});
